// Ornamental divider row used above and below page titles:
//   ─── ✦ ───
// Pass position="bottom" to get the bottom-variant spacing.
export const DecorativeRow = ({ position }) => (
  <div
    className={
      position === "bottom"
        ? "page-header-decoration page-header-decoration--bottom"
        : "page-header-decoration"
    }
  >
    <span className="decorative-line"></span>
    <span className="decorative-star">✦</span>
    <span className="decorative-line"></span>
  </div>
);
